import Image from 'next/image'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'
import { ROUTES } from '@utils/routes'
import { getNameSlug } from '@utils/helper'

interface ProductBrandProps {
  data: any
}

const ProductBrand: React.FC<ProductBrandProps> = ({ data }) => {
  const { t: translate } = useTranslation('pdp')
  const brandData = data?.mag_attributes?.find(
    (attr: { attribute_code: string }) => attr.attribute_code === 'brand_info',
  )?.value[0]

  return (
    <div className="border p-4 py-7 mt-5 flex flex-col items-center">
      {brandData?.brand_image && (
        <Image
          src={brandData?.brand_image}
          alt={translate('productBrand.brandImageAlt')}
          className="rounded-md w-36 lg:w-44"
          width={200}
          height={100}
          priority
        />
      )}
      <Link
        href={encodeURI(
          `${ROUTES.BRANDS}/${getNameSlug(brandData?.brand_titile)}`,
        )}
        className="mt-4 font-semibold text-brand text-lg underline cursor-pointer"
      >
        {translate('productBrand.viewAllProducts', {
          brandTitle: brandData?.brand_titile,
        })}
      </Link>
    </div>
  )
}

export default ProductBrand
